import React from "react";

const UseCaseCard = ({ data: { tag, heading, subHeading, img }, index }) => {
  return (
    <div className={`use__card  ${index % 2 === 0 ? "use__card-order" : ""} `}>
      <img className="use__card-background reveal-from-bottom" src={img} alt="case" />
      <div className={`use__card-container`}>
        <div className="use__card-tag reveal-from-top">{tag}</div>
        <div className="use__card-heading reveal-from-top">{heading} </div>
        <div
          className="use__card-sub reveal-from-bottom"
          data-reveal-delay="200"
        >
          {subHeading}{" "}
        </div>
      </div>
    </div>
  );
};

export default UseCaseCard;
